import {Component, EventEmitter, Input, OnInit, Output} from '@angular/core';
import {CommonConstant} from '../../../../app.constants';

@Component({
  selector: 'page-count-item',
  templateUrl: './page-count-item.component.html',
  styleUrls: ['./page-count-item.component.scss']
})
export class PageCountItemComponent implements OnInit {
  @Input() maximumItem: number;
  @Output() pageChange: EventEmitter<any> = new EventEmitter<any>();
  public numOfSelectedItem = CommonConstant.MAX_ITEM_PER_PAGE_REPORT;

  ngOnInit() {
    if (this.maximumItem < CommonConstant.MAX_ITEM_PER_PAGE_REPORT) {
      this.numOfSelectedItem = this.maximumItem;
    }
  }

  onPageChange() {
    this.pageChange.emit(this.numOfSelectedItem);
  }

  onDecreasePage() {
    const pageNumber = Math.floor(this.numOfSelectedItem / CommonConstant.MAX_ITEM_PER_PAGE_REPORT);
    const partialPage = this.numOfSelectedItem % CommonConstant.MAX_ITEM_PER_PAGE_REPORT;
    if (partialPage > 0 && pageNumber > 0) {
      this.numOfSelectedItem = pageNumber * CommonConstant.MAX_ITEM_PER_PAGE_REPORT;
    } else if (this.numOfSelectedItem > CommonConstant.MAX_ITEM_PER_PAGE_REPORT) {
      this.numOfSelectedItem = this.numOfSelectedItem - CommonConstant.MAX_ITEM_PER_PAGE_REPORT;
    }
    this.onPageChange();
  }

  onIncreasePage() {
    const pageNumber = Math.floor(this.numOfSelectedItem / CommonConstant.MAX_ITEM_PER_PAGE_REPORT);
    const partialPage = this.numOfSelectedItem % CommonConstant.MAX_ITEM_PER_PAGE_REPORT;
    if (partialPage > 0) {
      this.numOfSelectedItem = (pageNumber + 1) * CommonConstant.MAX_ITEM_PER_PAGE_REPORT;
    }  else {
      this.numOfSelectedItem = this.numOfSelectedItem + CommonConstant.MAX_ITEM_PER_PAGE_REPORT;
    }
    if (this.numOfSelectedItem > this.maximumItem) {
      this.numOfSelectedItem = this.maximumItem;
    }
    this.onPageChange();
  }

}



// WEBPACK FOOTER //
// ./src/app/main/measure/measure-pdf-export/page-count-item/page-count-item.component.ts